import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

import { useLenis } from '@/lib/useLenis';
import { Navbar } from '@/components/site/Navbar';
import { Hero } from '@/components/site/Hero';
import { TeluguPalette } from '@/components/site/TeluguPalette';
import { Philosophy } from '@/components/site/Philosophy';
import { FilmShowcase } from '@/components/site/FilmShowcase';
import { Process } from '@/components/site/Process';
import { About } from '@/components/site/About';
import { Testimonials } from '@/components/site/Testimonials';
import { Contact } from '@/components/site/Contact';
import { Footer } from '@/components/site/Footer';
import { FloatingWhatsApp } from '@/components/site/FloatingWhatsApp';

const Landing = () => {
    useLenis();
    return (
        <div data-testid="landing-page" className="bg-ink text-bone min-h-screen">
            <Navbar />
            <main>
                <Hero />
                <TeluguPalette />
                <Philosophy />
                <FilmShowcase />
                <Process />
                <About />
                <Testimonials />
                <Contact />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
};

function App() {
    return (
        <div className="App">
            <Toaster
                theme="dark"
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: '#0F0F0F',
                        border: '1px solid rgba(255,255,255,0.1)',
                        color: '#F5F5F5',
                    },
                }}
            />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
